import { Campus, ExperienceType, Pronouns, YesNoMaybeAlready } from '../../../api/client';
import { DefaultProfileNonReportedText } from './StudentProfileHelpers';

export const formatCampus = (campus?: Campus): string => {
  switch (campus) {
    case Campus.Tampa:
      return 'Tampa';
    case Campus.StPetersburg:
      return 'St. Petersburg';
    case Campus.SarasotaManatee:
      return 'Sarasota-Manatee';
    default:
      return '';
  }
};

export const formatSemester = (semester?: number): string => {
  switch (semester) {
    case 0:
      return 'Spring';
    case 1:
      return 'Summer';
    case 2:
      return 'Fall';
    default:
      return '';
  }
};

export const formatExperienceType = (type?: ExperienceType): string => {
  switch (type) {
    case ExperienceType.CommunityService: return "Community Service"
    case ExperienceType.StudentOrganizations: return "Student Organizations"
    case ExperienceType.Job: return "Job"
    case ExperienceType.Internship: return "Internship"
    case ExperienceType.Research: return "Research"
    case ExperienceType.CreativeProjects: "Creative Projects"
    case ExperienceType.Writing: return "Writing" 
    case ExperienceType.Sports: return "Sports"
    case ExperienceType.MusicalEnsembles: return "Musical Ensembles" 
    case ExperienceType.PoliticalCampaigns: return "Political Campaigns"
    case ExperienceType.Publications: return "Publications"
    case ExperienceType.ConferencePresentations: return "Conference Presentations"
    case ExperienceType.StudyAbroad: return "Study Abroad"
    case ExperienceType.Other: return "Other"
    default: return "Other"
  }
}

export const booleanFormatter = (plans?: boolean): string =>
  plans ? 'Yes' : 'No';

export const YesNoMaybeFormatter = (plans?: YesNoMaybeAlready): string => {
  switch (plans) {
    case YesNoMaybeAlready.Yes:
      return 'Yes';
    case YesNoMaybeAlready.No:
      return 'No';
    case YesNoMaybeAlready.Maybe:
      return 'Maybe';
    case YesNoMaybeAlready.DoNotKnow:
      return 'Do not know';
    default:
      return DefaultProfileNonReportedText;
  }
}

export const formatLanguages = (languageList?: Array<{ name: string }>): JSX.Element[] =>
  languageList?.map(l => (
    <div key={l.name} className="bg-green-500 text-white px-3 py-1 rounded-full mr-2 mt-4 inline-block">
      {l.name}
    </div>
  )) || [];

export const formatPronouns = (pronouns?: Pronouns): string => {
  switch (pronouns) {
    case Pronouns.HeHim:
      return 'He/Him';
    case Pronouns.SheHer:
      return 'She/Her';
    case Pronouns.TheyThem:
      return 'They/Them';
    case Pronouns.Other:
      return 'Other';
    default:
      return 'Prefer not to say';
  }
};
